module.exports = __webpack_public_path__ + "static/img/tipos de eval.9b6caa5a.png";